"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Container = _interopRequireDefault(require("../../01_atoms/Container"));

var _Page = _interopRequireDefault(require("../../01_atoms/Page"));

var _HomeTopBar = _interopRequireDefault(require("../../02_molecules/HomeTopBar"));

var _BookingForm = _interopRequireDefault(require("../../02_molecules/BookingForm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BookingFormPage = function BookingFormPage(_ref) {
  var formFields = _ref.formFields,
      onChange = _ref.onChange,
      onSubmit = _ref.onSubmit,
      translationManager = _ref.translationManager,
      translatorForNamespace = _ref.translatorForNamespace,
      dropDownSearch = _ref.dropDownSearch,
      departures = _ref.departures,
      arrivals = _ref.arrivals,
      disableReturnField = _ref.disableReturnField;
  var t = translatorForNamespace('BookingFormPageUI');
  return /*#__PURE__*/_react["default"].createElement(_Page["default"], null, /*#__PURE__*/_react["default"].createElement(_HomeTopBar["default"], {
    translatorForNamespace: translatorForNamespace
  }, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_BookingForm["default"], {
    formData: formFields,
    onChange: onChange,
    onSubmit: onSubmit,
    translationManager: translationManager,
    translator: t,
    dropDownSearch: dropDownSearch,
    departures: departures,
    arrivals: arrivals,
    disableReturnField: disableReturnField
  }))), /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: {
      marginTop: '5%'
    }
  }));
};

var _default = BookingFormPage;
exports["default"] = _default;